/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SocialShareType } from '@app/app/shared/models/public-share/public-share.model';
import { ShareService } from '@app/app/shared/services/share/share.service';
import { StyleguideModule } from '@app/app/shared/styleguide/styleguide.module';
import { Cancel01Icon, Copy01Icon, Link04Icon } from '@hugeicons/core-free-icons/index';
import { TranslocoModule } from '@ngneat/transloco';

export interface SocialShareV3Item {
  name: SocialShareType;
  title: string;
  image: string;
}

@Component({
  selector: 'ptl-social-share-url-v3',
  templateUrl: './social-share-url-v3.component.html',
  styleUrls: ['./social-share-url-v3.component.scss'],
  standalone: true,
  imports: [CommonModule, StyleguideModule, TranslocoModule],
})
export class SocialShareUrlV3Component {
  shareUrl: string;

  readonly Link04Icon = Link04Icon;
  readonly Cancel01Icon = Cancel01Icon;
  readonly Copy01Icon = Copy01Icon;

  socialShareItems: SocialShareV3Item[] = [
    { name: SocialShareType.LINKEDIN, title: 'LinkedIn', image: 'assets/icons/logo-linkedin.png' },
    { name: SocialShareType.TWITTER, title: 'X', image: 'assets/icons/logo-x.png' },
    { name: SocialShareType.FACEBOOK, title: 'Facebook', image: 'assets/icons/logo-facebook.png' },
    { name: SocialShareType.WHATSAPP, title: 'WhatsApp', image: 'assets/icons/logo-whatsapp.png' },
  ];

  private dialogRef = inject(MatDialogRef<SocialShareUrlV3Component>);
  private shareService = inject(ShareService);
  data: { shareUrl: string } = inject(MAT_DIALOG_DATA);

  constructor() {
    this.shareUrl = this.data.shareUrl;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  copyLink(): void {
    this.shareService.shareAction(SocialShareType.COPY, this.shareUrl);
  }

  shareAction(type: SocialShareType): void {
    this.shareService.shareAction(type, this.shareUrl);
  }
}
